export default __webpack_public_path__ + "static/media/planit_logo_dark_full.08bc911f.svg";